module.exports = __webpack_public_path__ + "img/Sanford-Stadium-t-22953-031_1.24fb61fe.jpg";